type ImportColumnHeadings = Record<string, string>

/**
 * Map each import field to the first matching heading in any supported language.
 * Missing fields stay at -1 so the import mapping UI can leave them unselected.
 */
export function buildImportColumnMap(
  headings: readonly string[],
  columnsByLanguage: readonly ImportColumnHeadings[]
): Record<string, number> {
  const keys = Array.from(new Set(columnsByLanguage.flatMap(columns => Object.keys(columns))))

  return Object.fromEntries(
    keys.map(key => [key, headings.findIndex(heading => columnsByLanguage.some(columns => columns[key] === heading))])
  )
}
